import { Tag } from 'mojo-tag';

import { Job } from './job';

export interface JobTag extends Tag {
  status: string;
  clientReqId: string;
}

export class JobTagAdapter {
  static toOption({id, title, status, clientReqId}: Job): JobTag {
    return { id, label: title, status,  clientReqId};
  }
}
